<nav class="menu">

  <!-- =========================
       LOGO
       ========================= -->

  <a
    href="#top"
    class="menu-logo"
    aria-label="Wróć na górę strony"
  >
    <span>M</span>

    <img
      src="../images/galazka.png"
      alt=""
      aria-hidden="true"
    >

    <span>M</span>
  </a>


  <!-- =========================
       HAMBURGER
       ========================= -->

  <button
    class="menu-toggle"
    aria-label="Otwórz menu"
    aria-expanded="false"
  >
    ☰
  </button>


  <!-- =========================
       LINKI
       ========================= -->

  <div class="menu-linki">
    <a href="#ceremonia">ŚLUB</a>
    <a href="#rejs">REJS STATKIEM</a>
    <a href="#wesele">WESELE</a>
    <a href="#nasza_historia">NASZA HISTORIA</a>
    <a href="#rsvp">RSVP</a>
  </div>

</nav>


<style>

  /* =========================
     MENU
     ========================= */

  .menu {
    position: fixed;

    top: 0;
    left: 0;
    right: 0;

    width: auto;
    max-width: 100%;

    height: 80px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0 40px;

    box-sizing: border-box;

    background-color: #f7f3e8;

    z-index: 1000;

    box-shadow:
      0 2px 12px rgba(0, 0, 0, 0.04);
  }


  /* =========================
     LOGO
     ========================= */

  .menu-logo {
    display: inline-flex;
    align-items: center;

    gap: 0.35em;

    flex-shrink: 0;

    font-family: "The Seasons", serif;
    font-size: 1.25em;

    color: #2f2b26;

    text-decoration: none;

    cursor: pointer;
  }


  .menu-logo img {
    display: block;

    width: 1.6em;
    height: auto;
  }


  /* =========================
     LINKI
     ========================= */

  .menu-linki {
    display: flex;
    align-items: center;

    gap: 30px;

    min-width: 0;
  }


  .menu-linki a {
    position: relative;

    display: block;

    font-family: "Cinzel", serif;
    font-size: 14px;

    text-decoration: none;

    color: #2f2b26;

    padding: 8px 0;

    white-space: nowrap;
  }


  /* =========================
     PODKREŚLENIE
     ========================= */

  .menu-linki a::after {
    content: "";

    position: absolute;

    left: 50%;
    bottom: 0;

    width: 0;
    height: 1px;

    background-color: #2f2b26;

    transform: translateX(-50%);

    transition: width 0.25s ease;
  }


  /* .menu-linki a:hover::after, */
  .menu-linki a.active::after {
    width: 100%;
  }


  /* =========================
     HAMBURGER
     ========================= */

  .menu-toggle {
    display: none;

    flex-shrink: 0;

    border: 0;

    padding: 0;

    background: transparent;

    color: #2f2b26;

    font-size: 2em;
    line-height: 1;

    cursor: pointer;
  }

  #ceremonia,
  #rejs,
  #wesele,
  #nasza_historia,
  #rsvp {
    scroll-margin-top: 80px;
  }


  /* =========================
     MOBILE
     ========================= */

  @media (max-width: 800px) {
    #ceremonia, 
    #rejs, 
    #wesele, 
    #nasza_historia, 
    #rsvp { 
      scroll-margin-top: 70px; 
    }
    .menu {
      height: 70px;

      padding:
        0
        20px;
    }


    .menu-toggle {
      display: block;
    }


    .menu-linki {
      position: absolute;

      top: 70px;
      left: 0;
      right: 0;

      width: auto;
      max-width: 100%;

      display: none;

      flex-direction: column;

      gap: 0;

      box-sizing: border-box;

      padding: 0.6em 0;

      background-color: #f7f3e8;

      box-shadow:
        0 8px 16px rgba(0, 0, 0, 0.05);
    }


    .menu-linki.open {
      display: flex;
    }


    .menu-linki a {
      width: 100%;

      box-sizing: border-box;

      padding:
        1em
        1.5em;

      text-align: center;
    }


    .menu-linki a::after {
      bottom: 0.5em;
    }


    /* .menu-linki a:hover::after, */
    .menu-linki a.active::after {
      width: 40px;
    }

  }

</style>


<script>

  function initMenu() {

    const logo =
      document.querySelector(".menu-logo");

    const toggle =
      document.querySelector(".menu-toggle");

    const linksContainer =
      document.querySelector(".menu-linki");

    const menuLinks =
      document.querySelectorAll(".menu-linki a");

    const sections =
      document.querySelectorAll(
        "#ceremonia, #rejs, #wesele, #nasza_historia, #rsvp"
      );


    /* =========================
       LOGO -> GÓRA STRONY
       ========================= */

    if (logo) {

      logo.addEventListener(
        "click",
        (event) => {

          event.preventDefault();

          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });

        }
      );

    }


    /* =========================
       MENU MOBILE
       ========================= */

    if (toggle && linksContainer) {

      toggle.addEventListener(
        "click",
        () => {

          const isOpen =
            linksContainer.classList.toggle(
              "open"
            );

          toggle.setAttribute(
            "aria-expanded",
            isOpen
              ? "true"
              : "false"
          );

        }
      );


      menuLinks.forEach((link) => {

        link.addEventListener(
          "click",
          () => {

            linksContainer.classList.remove(
              "open"
            );

            toggle.setAttribute(
              "aria-expanded",
              "false"
            );

          }
        );

      });

    }


    /* =========================
       AKTYWNA SEKCJA
       ========================= */

    function setActiveLink() {

      let currentSection = "";

      // const menuHeight =
      //   window.innerWidth <= 800
      //     ? 70
      //     : 80;

      const marker =
        window.innerHeight * 0.4;


      sections.forEach((section) => {

        const rect =
          section.getBoundingClientRect();

        if (
          rect.top <= marker &&
          rect.bottom > marker
        ) {

          currentSection =
            section.id;

        }

      });


      menuLinks.forEach((link) => {

        const href =
          link.getAttribute("href");

        const sectionId =
          href
            ? href.replace("#", "")
            : "";

        link.classList.toggle(
          "active",
          sectionId === currentSection
        );

      });

    }


    /* =========================
       SCROLL
       ========================= */

    window.addEventListener(
      "scroll",
      setActiveLink,
      {
        passive: true
      }
    );


    window.addEventListener(
      "resize",
      setActiveLink
    );


    /* po wejściu na stronę */

    setActiveLink();

  }


  /* =========================
     START DOPIERO PO DOM
     ========================= */

  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initMenu
    );

  } else {

    initMenu();

  }

</script>